import { render, staticRenderFns } from "./ChangeUserLanguage.vue?vue&type=template&id=f8356224"
import script from "./ChangeUserLanguage.vue?vue&type=script&lang=js"
export * from "./ChangeUserLanguage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports